import * as React from "react";

import "./step-1-map.scss";

import {cs}              from "@Common/react/chain-services";
import {consumeContext}  from "@Common/react/context";
import {UseState}        from "@Common/react/use-state";
import {parseDateFormat} from "@Common/utils/date/parse-date-format";

import {cx}                from "emotion";
import {GlobalResizeState} from "../../../../../../browser/global-resize-state";
import {Header}            from "../../common/header/header";
import {ConfirmCancel}     from "../../common/confirm-cancel";
import {HomeownersSideBar} from "./homeowners-side-bar/homeowners-side-bar";
import {MapSection}        from "./map-section/map-section";

export const Step1Map = ({next}) => cs(
    consumeContext("apis"),
    ["viewSize", (_, next) => GlobalResizeState({
        translate: ({width, height}) => height < 900 ? {
            size: "md",
            showFeedback: width >= 480 && window.document.getElementsByClassName("_hj-ETLL8__MinimizedWidgetMiddle__label")[0],
        } : {
            size: "lg",
            showFeedback: width >= 480 && window.document.getElementsByClassName("_hj-ETLL8__MinimizedWidgetMiddle__label")[0],
        },
        next,
    })],
    ["searchRequest", ({}, next) => UseState({next})],
    ["searchResult", ({}, next) => UseState({next})],
    ["mapSection", ({searchResult, viewSize}, next) => MapSection({
        zipCodes: searchResult.value?.zipCodes.filter(zip => !!zip.polygon),
        viewSize: viewSize.size,
        next
    })],
    ["homeownersSideBar", ({viewSize, searchRequest, searchResult, mapSection}, next) => HomeownersSideBar({
        viewSize: viewSize.size,
        searchRequest,
        searchResult,
        renderErrorNoti: mapSection.renderErrorNoti,
        next
    })],
    ["confirmCancel", (_, next) => ConfirmCancel({next})],
    ({homeownersSideBar, searchRequest, searchResult, mapSection, viewSize, confirmCancel}) => next({
        onPassiveClose: searchResult.value && confirmCancel,
        getRequestData: () => {
            const df = parseDateFormat("yyyy-mm-dd");
            return {
                ...searchRequest.value,
                startDate: df.formatDate(searchRequest.value.startDate),
                endDate: df.formatDate(searchRequest.value.endDate),
                customQty: homeownersSideBar.customQty ? homeownersSideBar.customQty : null,
            }
        },
        render: ({onCancel, cancelLabel, onNext}) => cs(
            ["nextAction", ({}, next) => next(homeownersSideBar.getNextAction({onNext}))],
            ({nextAction}) => (
                <div className="step-1-map-9r6">
                    {Header({
                        icon: require("../../../../mailing-icons/listtype-homeowners.svg"),
                        title: "New Homeowners",
                        subTitle: "Reach every new homeowner in your selected area.",
                    })}

                    <div className="content">
                        {homeownersSideBar.render()}
                        {mapSection.render()}
                    </div>

                    <div className="footer">
                        {viewSize.showFeedback && <a {...{
                            className: "feedback",
                            onClick: () => {
                                // @ts-ignore for warning against missing click function
                                window.document.getElementsByClassName("_hj-ETLL8__MinimizedWidgetMiddle__label")[0]?.click();
                            },
                            "xd-qa-type": "link",
                            "xd-qa-name": "New Homeowners Feedback"
                        }}>
                            Have feedback?
                        </a>}
                        <button {...{
                            className: "cancel",
                            onClick: async () => {
                                if (searchResult.value) {
                                    if (await confirmCancel()) {
                                        onCancel();
                                    }
                                } else {
                                    onCancel();
                                }
                            },
                            "xd-qa-type": "button",
                            "xd-qa-name": "New Homeowners " + cancelLabel,
                        }}>
                            {cancelLabel}
                        </button>
                        {nextAction && (
                            <button {...{
                                className: cx("next", {disabled: nextAction.disabled}),
                                onClick: nextAction.action,
                                "xd-qa-type": "button",
                                "xd-qa-name": "New Homeowners Next",
                            }}>
                                Next
                            </button>
                        )}
                    </div>
                </div>
            ),
        ),
    })
);